module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "switch-wrap",
    class: [{
      'is-disabled': _vm.disabled
    }, _vm.sizeClass],
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggle($event)
      }
    }
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "checkbox",
      "name": _vm.name
    },
    domProps: {
      "checked": _vm.on
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switchery",
    class: [{
      'on': _vm.on
    }, _vm.typeClass, _vm.sizeClass, {
      'has-text': _vm.hasText
    }]
  }, [_c('small', {
    staticClass: "switcher"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.showText))])]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-597d7d51!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/switch/Switch.vue
// module id = 340
// module chunks = 0